export default {
  region: 'Region',
  remove: 'Remove',
  removed: 'Removed',
  result: 'Result',
  retry: 'Retry',
  risk: 'Risk',
  risks: 'Risks',
  revoke: 'Revoke'
}
